import React from 'react';
import type { SubscriptionComputedState } from '../../../types';

const STYLES: Record<string, string> = {
  active: 'bg-green-100 text-green-800',
  grace: 'bg-amber-100 text-amber-800',
  trialing: 'bg-blue-100 text-blue-800',
  expired: 'bg-red-100 text-red-800',
  none: 'bg-gray-100 text-gray-600',
  cancelled: 'bg-gray-100 text-gray-700',
  pending: 'bg-yellow-100 text-yellow-800',
};

interface SubscriptionStatusBadgeProps {
  state: SubscriptionComputedState;
}

export const SubscriptionStatusBadge: React.FC<SubscriptionStatusBadgeProps> = ({ state }) => {
  const key = (state || 'none').toLowerCase();
  const label = key === 'none' ? 'No subscription' : key.replace(/_/g, ' ');
  return (
    <span
      className={`inline-flex px-2 py-1 rounded-full text-xs font-medium capitalize ${STYLES[key] || STYLES.none}`}
    >
      {label}
    </span>
  );
};
